import React from 'react';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

/**
 * OfflineBanner
 * Fixed banner shown at the top of the page when the device is offline.
 * Auto-hides when connection is restored.
 */
export function OfflineBanner() {
  const { isOnline } = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="fixed top-0 left-0 right-0 z-[60] flex items-center justify-center gap-2
                 bg-[#DC2626] text-white text-sm font-medium py-2 px-4"
    >
      <WifiOff className="w-4 h-4 shrink-0" />
      <span>You're offline — some features may be unavailable</span>
    </div>
  );
}
